export default "__VITE_ASSET__5Kj1idIO__"